module.exports = __webpack_public_path__ + "static/img/category-select-bg.9975ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/category-select-bg.png
// module id = wHvD
// module chunks = 1